import React, { useCallback, useMemo } from 'react';
import { injectIntl } from 'react-intl';

import {
  Row,
  Col,
  Button,
  Card,
  Input,
  Form,
  InputNumber,
} from 'antd';

import {budgetValidation as validation} from './validation';
import useForm from 'utils/useForm';

import './style.less';

const BudgetForm = ({
  intl,
  type,
  record,
  index,
  onSave,
  onCancel,
}) => {
  const t = intl.messages;
  const defaults = record;
  const validateForm = useMemo(() => validation(t), [ t ]);

  const submitForm = () => {
    const { concept, amount } = values;
    onSave(
      type, index, { concept, amount }
    );
  };

  const {
    values,
    handleChange,
    handleChangeEvent,
    handleSubmit,
    isDirty,
    errors,
  } = useForm({
    callback: submitForm,
    validate: validateForm,
    defaultValues: defaults,
  });

  const getValue = useCallback(
    (name) => (typeof values[name] === 'undefined' ? defaults[name] : values[name]),
    [values, defaults]
  );
  const showError = useCallback(
    (name) => (!isDirty(name) && errors[name]) || '',
    [isDirty, errors]
  );

  return (
    <Row>
      <Col span={24} className="form-input-wrapper">
        <Card className="form-input-card">
          <Row gutter={10}>
            <Col span={18}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('concept') ? 'error' : '' }
                help={ showError('concept') }
                label={ t.concept }
                colon={false}
                required
              >
                <Input
                  placeholder={ t.concept }
                  name="concept"
                  value={ getValue('concept') }
                  onChange={handleChangeEvent}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('amount') ? 'error' : '' }
                help={ showError('amount') }
                label={ t.amount }
                colon={false}
                required
              >
                <InputNumber
                  placeholder={ t.amount }
                  name="amount"
                  value={ getValue('amount') }
                  onChange={(value) => handleChange('amount')(value)}
                />
              </Form.Item>
            </Col>
            <Col span={2}>
              <Button
                  type="primary"
                  onClick={handleSubmit}
                >
                  { t.add }
              </Button>
            </Col>
            <Col span={2}>
              <Button onClick={() => onCancel(type, index)}>
                { t.cancel }
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
};

export default injectIntl(BudgetForm);
